import { createCommand, LexicalCommand } from 'lexical'

import { InsertImagePayload } from './interface'

export const UPLOAD_IMAGE_COMMAND: LexicalCommand<unknown> = createCommand(
  'UPLOAD_IMAGE_COMMAND'
)

export const INSERT_IMAGE_COMMAND: LexicalCommand<InsertImagePayload> =
  createCommand('INSERT_IMAGE_COMMAND')
